import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-visio-inprocess.component.ajs.html';

const MODULE_NAME = 'agentBookingVisioInprocess';

class AgentBookingVisioInprocessCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingVisioInprocess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingVisioInprocessCtrl];
}

export default MODULE_NAME;
